import React from "react";
import MessageContent from "./components/MessageContent";
import AcademicSection from "./components/AcademicSection";
import MessageContentMobile from "./components/MessageContentMobile";
import AcademicSectionMobile from "./components/AcademicSectionMobile";

const MessageContainer = () => {
  return (
    <div className="lg:pt-numbers-100x">
      <div className=" translate-y-numbers-100">
        <div className="hidden lg:block">
          <MessageContent />
        </div>
        <div className="lg:hidden">
          <MessageContentMobile />
        </div>
      </div>
        <div className="hidden lg:block">
      <AcademicSection />
        </div>
        <div className="lg:hidden">
      <AcademicSectionMobile />
        </div>
    </div>
  );
};

export default MessageContainer;
